import { mediaQueryLarge, onDocumentReady } from '@theme/utilities';

function getActiveSlide(gallery) {
  return gallery.querySelector('slideshow-slide[aria-hidden="false"]') || gallery.querySelector('slideshow-slide');
}

function getSlideRatio(slide) {
  if (!slide) return null;

  const inlineRatio = slide.style.getPropertyValue('--media-preview-ratio');
  const computedRatio = getComputedStyle(slide).getPropertyValue('--media-preview-ratio');
  const ratio = parseFloat(inlineRatio || computedRatio);

  if (Number.isFinite(ratio) && ratio > 0) return ratio;

  const image = slide.querySelector('img');
  if (image?.naturalWidth && image?.naturalHeight) return image.naturalWidth / image.naturalHeight;

  return null;
}

function syncGalleryHeight(gallery) {
  const scroller = gallery.querySelector('slideshow-slides');
  const container = gallery.querySelector('slideshow-container');
  const slides = gallery.querySelectorAll('slideshow-slide.product-media-container');

  if (!(scroller instanceof HTMLElement) || !(container instanceof HTMLElement) || !slides.length) return;

  if (mediaQueryLarge.matches) {
    container.style.removeProperty('height');
    scroller.style.removeProperty('height');
    slides.forEach((slide) => slide.style.removeProperty('height'));
    return;
  }

  const activeSlide = getActiveSlide(gallery);
  const ratio = getSlideRatio(activeSlide);
  const width = activeSlide?.getBoundingClientRect().width || container.getBoundingClientRect().width;

  if (!ratio || !width) return;

  const targetHeight = `${width / ratio}px`;
  container.style.height = targetHeight;
  scroller.style.height = targetHeight;
  slides.forEach((slide) => {
    slide.style.height = targetHeight;
  });
}

function bindGallery(gallery) {
  if (!(gallery instanceof HTMLElement) || gallery.dataset.bravoartMobileHeightBound === 'true') return;
  gallery.dataset.bravoartMobileHeightBound = 'true';

  let rafId = 0;
  const schedule = () => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      syncGalleryHeight(gallery);
    });
  };

  schedule();
  gallery.addEventListener('slideshow:select', schedule);

  const observer = new MutationObserver(schedule);
  observer.observe(gallery, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-hidden', 'style'],
  });

  gallery.querySelectorAll('img').forEach((img) => {
    if (img.complete) return;
    img.addEventListener('load', schedule, { once: true });
  });

  window.addEventListener('resize', schedule);
}

function init() {
  document.querySelectorAll('.product-information media-gallery').forEach(bindGallery);
}

onDocumentReady(init);
